import React from 'react'
import styles from './logo.module.css';

const logoUrl = 'https://www.wagetap.com/assets/img/logo.svg';

export default ({ size }) => (
  <div className={size === 'small' ? styles.logoContainerSmall : styles.logoContainer}>
    <a href="/"><img src={logoUrl} alt="Wagetap logo"/></a>
  </div>
);
